
export const calculateSubscriptionSummary = (childAccounts) => {
    return childAccounts.reduce((acc, { subscription }) => {
        const plan = subscription?.subscription;
        const isCancel = subscription?.dj_stripe_subscription?.cancel_at_period_end;
        const planPrice = Number(plan?.price || 0);
        const orderCost = Number(subscription?.usage?.order_cost || 0);
        const smsCost = Number(subscription?.usage?.sms_cost || 0);
        const amount = planPrice + orderCost + smsCost;

        if (amount > 0 && !isCancel) {
            if (plan?.recurring_interval === 2) acc.annualTotal += amount;
            else if (plan?.recurring_interval === 1) acc.monthlyTotal += amount;
            acc.total += amount;
        }

        return acc;
    },
        { annualTotal: 0, monthlyTotal: 0, total: 0 });
};

export const getNextPaymentInfo = (childAccounts) => {
    const today = new Date();

    const paymentDates = childAccounts
        .map(account => account.subscription?.current_period_end)
        .filter(date => date)
        .map(date => new Date(date))
        .filter(date => date >= today)
        .sort((a, b) => a - b);

    if (paymentDates.length === 0) {
        return {
            nextPaymentDate: 'N/A',
            daysUntilPayment: 'N/A',
        }
    };

    const nextPaymentDate = paymentDates[0];
    const daysRemaining = Math.ceil((nextPaymentDate - today) / (1000 * 60 * 60 * 24));

    return {
        nextPaymentDate: nextPaymentDate.toISOString().split("T")[0],
        daysUntilPayment: daysRemaining
    };
}